<template>
  <div class="main">
    <c-panel title="Motoristas" titleIcon="fas fa-id-badge">
      <list></list>
    </c-panel>
  </div>
</template>

<script>
import list from "./list"

export default {
  components: { list }
}
</script>

